<template>
	<div class="ai_container">
		<Header :onClose="handleClose" />
		<div class="ai_wrapper">
			<h1 class="heading_3">
				AI는 지금 견적 산정중 🔎<br />완료되면 링크를 보내드려요
			</h1>
			<!-- 확인 필요 -->
			<p class="body_6 f_gray_4" style="marginTop: 8px">
				최대 10분 정도 소요될 수 있어요
			</p>
			<ul class="process_list">
				<NumberListItem v-for="(item, index) in items" :key="index" :index="index + 1">
					<div>
						<p :class="`heading_6 ${items.length === index + 1 && 'f_primary_1'}`">
							{{ item.title }}
						</p>
						<div v-if="item.imageUrl" class="list_content_wrapper">
							<div class="image_wrapper">
								<img :src="item.imageUrl" />
							</div>
							<div class="content_wrapper">
								<p>{{ item.desc1 }}</p>
								<b class="heading_7">{{ item.desc2 }}</b>
							</div>
						</div>
					</div>
				</NumberListItem>
			</ul>
		</div>
	</div>
</template>

<script>
import Header from '../../components/ai/AiHeader.vue'
import NumberListItem from '../../components/ai/AiNumberListItem.vue'

export default {
	name:'AiLoading',
	data() {
		return {
			items: [
				{
					title: '알림톡 확인',
					imageUrl: '/static/images/ai/mailbox.png',
					desc1: '견적 산정이 완료되면',
					desc2: '카카오톡 링크 확인'
				},
				{
					title: '견적 비용 결제',
					imageUrl: '/static/images/ai/pricetag.png',
					desc1: '알림톡 링크로 접속하여',
					desc2: '온라인 결제'
				},
				{
					title: 'AI 견적 확인',
					imageUrl: '/static/images/ai/phone.png',
					desc1: 'AI가 산출한 견적',
					desc2: '자세한 견적 확인'
				},
				{
					title: '수리 상담',
					imageUrl: '/static/images/ai/repair.png',
					desc1: '공업사 견적을 전송하고',
					desc2: '수리 상담 받으세요'
				},
				{
					title: '제휴매장 방문하기!'
				}
			]
		}
	},
	components: {
		Header,
		NumberListItem
	},
	methods: {
		handleClose() {
			this.$router.push({name: "AiMain"});
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/views/ai/AiLoading.vue